// extracted by mini-css-extract-plugin
export var active = "lcSidebarCategorySubitem-module--active--e68f9";
export var arrowIcon = "lcSidebarCategorySubitem-module--arrowIcon--484a3";
export var container = "lcSidebarCategorySubitem-module--container--74197";
export var head = "lcSidebarCategorySubitem-module--head--4c7a7";
export var items = "lcSidebarCategorySubitem-module--items--16a1d";
export var noScroll = "lcSidebarCategorySubitem-module--no-scroll--ab669";
export var open = "lcSidebarCategorySubitem-module--open--6daac";
export var selfActive = "lcSidebarCategorySubitem-module--selfActive--99468";
export var title = "lcSidebarCategorySubitem-module--title--bfae9";